import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/inventario/unidad_medida';
import Unidad from './unidadMedidaList';


const ms2p = (state) => {
  return {
    ...state.unidadMedida,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Unidad);
